import { render, staticRenderFns } from "./InstantSearch.vue?vue&type=template&id=15f5c9d2&"
import script from "./InstantSearch.vue?vue&type=script&lang=js&"
export * from "./InstantSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ebenhafkamp/Documents/Projects/tacpro/src/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f5c9d2')) {
      api.createRecord('15f5c9d2', component.options)
    } else {
      api.reload('15f5c9d2', component.options)
    }
    module.hot.accept("./InstantSearch.vue?vue&type=template&id=15f5c9d2&", function () {
      api.rerender('15f5c9d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/InstantSearch.vue"
export default component.exports